export const data = {
    name: "Incidents",
    layout: [],
};
export default data;